export namespace ImageAsset {
    export interface BoundingBox {
        Height: number
        Width: number
        Top: number
        Left: number
    }
    export function getImageBoundsFromFaces(boundingBoxes: BoundingBox[]): BoundingBox {
        if (boundingBoxes.length === 1) {
            return boundingBoxes[0]
        }

        const topMostValue = Math.min(...boundingBoxes.map((boundingBox) => boundingBox.Top))
        const leftMostValue = Math.min(...boundingBoxes.map((boundingBox) => boundingBox.Left))
        const bottomMostValue = Math.max(...boundingBoxes.map((boundingBox) => boundingBox.Top))
        const rightMostValue = Math.max(...boundingBoxes.map((boundingBox) => boundingBox.Left))

        const bottomMostTallest = boundingBoxes.filter((boundingBox) => boundingBox.Top === bottomMostValue).sort((a, b) => a.Height - b.Height)[0].Height
        const rightMostWidest = boundingBoxes.filter((boundingBox) => boundingBox.Left === rightMostValue).sort((a, b) => a.Width - b.Width)[0].Width

        if (!bottomMostTallest || !rightMostWidest) {
            return boundingBoxes[0]
        }

        const totalWidth = rightMostValue - leftMostValue + rightMostWidest
        const totalHeight = bottomMostValue - topMostValue + bottomMostTallest

        return {
            Height: totalHeight,
            Width: totalWidth,
            Left: leftMostValue,
            Top: topMostValue,
        }
    }

    export function getExtractOptions(boundingBox: BoundingBox, frame: { widthMM: number; heightMM: number }, image: { widthPx: number; heightPx: number }) {
        const imageWidth = image.widthPx
        const imageHeight = image.heightPx
        const frameAspectRatio = frame.widthMM / frame.heightMM
        const boundingBoxLeftGap = boundingBox.Left * imageWidth
        const boundingBoxTopGap = boundingBox.Top * imageHeight
        const boundingBoxWidth = boundingBox.Width * imageWidth
        const boundingBoxHeight = boundingBox.Height * imageHeight

        // Define a zoom factor. A value greater than 1 will zoom out.
        const zoomFactor = 2.5

        // Increase the height of the bounding box by the zoom factor.
        let newBoundingBoxHeight = boundingBoxHeight * zoomFactor

        // If the new height exceeds the image height, adjust it to fit within the image.
        if (newBoundingBoxHeight > imageHeight) {
            newBoundingBoxHeight = imageHeight
        }

        // Adjust the width of the bounding box to maintain the aspect ratio.
        let newBoundingBoxWidth = newBoundingBoxHeight * frameAspectRatio

        // If the new width exceeds the image width, adjust it to fit within the image.
        if (newBoundingBoxWidth > imageWidth) {
            newBoundingBoxWidth = imageWidth
            newBoundingBoxHeight = newBoundingBoxWidth / frameAspectRatio
        }

        // Calculate the increase in height.
        const heightIncrease = newBoundingBoxHeight - boundingBoxHeight

        // Adjust the top position of the bounding box.
        // let newBoundingBoxTop = boundingBoxTopGap - heightIncrease / 2
        let newBoundingBoxTop = boundingBoxTopGap - heightIncrease / 3

        // If the new top position is less than 0, adjust it to 0.
        if (newBoundingBoxTop < 0) {
            newBoundingBoxTop = 0
        }

        // If the new top position plus the height exceeds the image height, adjust the top position.
        if (newBoundingBoxTop + newBoundingBoxHeight > imageHeight) {
            newBoundingBoxTop = imageHeight - newBoundingBoxHeight
        }

        const widthIncrease = newBoundingBoxWidth - boundingBoxWidth
        let newBoundingBoxLeft = boundingBoxLeftGap - widthIncrease / 2
        if (newBoundingBoxLeft < 0) {
            newBoundingBoxLeft = 0
        }

        if (newBoundingBoxLeft + newBoundingBoxWidth > imageWidth) {
            newBoundingBoxLeft = imageWidth - newBoundingBoxWidth
        }

        const left = Math.round(newBoundingBoxLeft)
        const top = Math.round(newBoundingBoxTop)
        const width = Math.round(newBoundingBoxWidth)
        const height = Math.round(newBoundingBoxHeight)

        return {
            left,
            top,
            width,
            height,
        }
    }
}
